import { render, staticRenderFns } from "./settingAuth.vue?vue&type=template&id=3dfbb92a&scoped=true&"
import script from "./settingAuth.vue?vue&type=script&lang=js&"
export * from "./settingAuth.vue?vue&type=script&lang=js&"
import style0 from "./settingAuth.vue?vue&type=style&index=0&id=3dfbb92a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfbb92a",
  null
  
)

export default component.exports